import { normalizeImageUrl } from "@/src/utils/url";

/**
 * Drop-in replacement for <img> that normalises all src URLs.
 * Converts authenticated GCS console URLs (storage.cloud.google.com)
 * to the public CDN endpoint (storage.googleapis.com) so images
 * load in every browser, including Safari without a Google session.
 */
type SafeImageProps = React.ImgHTMLAttributes<HTMLImageElement>;

export function SafeImage({
  src,
  loading = "lazy",
  decoding = "async",
  ...props
}: SafeImageProps) {
  const safeSrc = typeof src === "string" ? normalizeImageUrl(src) ?? src : src;
  // `loading="lazy"` only defers off-screen images — in-viewport images (e.g.
  // a hero) still load immediately, so this is a safe global default. Callers
  // can override with loading="eager" + fetchPriority="high" for the LCP image.
  // eslint-disable-next-line @next/next/no-img-element
  return <img src={safeSrc} loading={loading} decoding={decoding} {...props} />;
}
